export const GAME_LIST = "GAME_LIST";
export const GAME_GET_FILTER_DATA = "GAME_GET_FILTER_DATA";
export const GAME_LIST_CREATE = "GAME_LIST_CREATE";
export const GAME_LIST_STORE = "GAME_LIST_STORE";
export const GAME_LIST_EDIT = "GAME_LIST_EDIT";
export const GAME_LIST_UPDATE = "GAME_LIST_UPDATE";
export const GAME_LIST_UPDATE_STATUS = "GAME_LIST_UPDATE_STATUS";
export const GAME_LIST_UPDATE_FAV = "GAME_LIST_UPDATE_FAV";
export const GAME_LIST_UPDATE_DEMO = "GAME_LIST_UPDATE_DEMO";